'use strict';

document.addEventListener("DOMContentLoaded",function(){

let play = document.getElementById("playbutton").innerText;
let pause = document.getElementById("pausebutton").innerText;
let reset = document.getElementById("reset").innerText;
let video = document.getElementsById("video").innerText;

video.addEventListener("ended", function(){

    video.currentTime = 0;
});

play.addEventListener("click",function(){
    video.play();

});

pause.addEventListener("click", function(){
    video.pause();
});

reset.addEventListener("click",function(){
video.pause();
video.currentTime = 0;
});

});

